export default function AreaEditController($q, $scope, $state, DataService, MapService, MapDrawService, NotificationService, OrgService, TitleService, MosFrameAnalyticsService) {
	"ngInject";

	const REFERRAL_ADOBE_ANALYTICS_FORM_NAME = 'Maps - Referral Toggle Form';
	var formStartExecutionCount = 0;
	const vm = this;

	vm.$onInit = () => {
		vm.areaId = $state.params.areaId;
		vm.loading = true;

		DataService.getArea(vm.areaId).then((area) => {
			TitleService.setTitleTranslate("pros-maps.area.edit.title", area);

			vm.map = DataService.instantMap();
			vm.reInit(area);

			//TODO: only do if status and assignments would even make it matter
			if (DataService.hasBoundary(vm.area)) {
				MapDrawService.isOutsideMission(vm.area).then((outside) => {
					vm.outsideMission = outside;
				});
			}

			vm.loading = false;
		}, NotificationService.exception(vm));
	};

	vm.reInit = (area) => {
		vm.original = area;
		vm.area = angular.extend({}, vm.original);
		vm.recenter();

		DataService.setMapOpts({selectedOrg: vm.original, force: true});
	};

	vm.recenter = () => {
		MapService.centerMap(vm.area, vm.map);
	};

	vm.resetBoundaries = () => {
		vm.loading = true;

		OrgService.updateAreaBoundary(vm.area.id, null, true).then((area) => (
			DataService.updateArea(area).then((area) => {
				vm.reInit(area);

				NotificationService.success("pros-maps.success.saved.boundary", null, area);
				vm.confirmReset = false;
				vm.loading = false;
			})
		), NotificationService.exception(vm));
	};

	vm.updateRelatedAreas = () => {
		if (vm.area.referrals !== vm.original.referrals) {
			return DataService.getOverlappingAreas(vm.area).then((overlappingAreas) => {
				if (overlappingAreas.length) {
					let areaIds = overlappingAreas.map((area) => (area.id)),
						missionId = $state.params.missionId;
					return OrgService.getMissionAreas(missionId, areaIds).then((areas) => (
						$q.all(areas.map(DataService.updateArea))
					));
				}
			});
		} else {
			let d = $q.defer();
			d.resolve();
			return d.promise;
		}
	};

	vm.save = () => {
		vm.loading = true;

		OrgService.updateArea(vm.area).then((area) => (
			DataService.updateArea(area).then(() => {
				vm.reInit(area);
				return vm.updateRelatedAreas().then(() => {
					NotificationService.success("pros-maps.success.saved.area", null, area);
					MosFrameAnalyticsService.formSubmit(REFERRAL_ADOBE_ANALYTICS_FORM_NAME);
					vm.exit();
				});
			})
		), () => {
			NotificationService.exception(vm);
			MosFrameAnalyticsService.formError(REFERRAL_ADOBE_ANALYTICS_FORM_NAME, ['server-error']);
		});
	};

	vm.exit = () => {
		$state.go("area", {areaId: vm.areaId});
	};

	vm.referralsToggleFormStart = () => {
		if (formStartExecutionCount) {
			MosFrameAnalyticsService.formStart(REFERRAL_ADOBE_ANALYTICS_FORM_NAME);
		}
		formStartExecutionCount++;
	}
}
